import React from 'react';
import { compose } from 'ramda';
import Cookies from 'js-cookie';
import { Typography } from '@deeptrue-frontend/ui';
import env from 'consts/env';
import AUTH from 'consts/auth';
import { useFormatMessage } from 'components/IntlProvider';
import signInSplash from 'assets/images/sign-in.png';
import StoreProvider from 'components/StoreProvider/StoreProvider';
import { withMetaDescription } from 'components/HeadProvider/HeadProvider';
import { SidePage } from 'components/Layout';
import api from 'api/api';
import { parseErrorsToFormik, errorsValidation } from 'components/Forms/utils';
import RecoverPassword, {
  SubmitHandler,
} from 'components/Forms/RecoverPassword';

const { connect, actions } = StoreProvider;

const InvitationAcceptance = ({ match: { params }, signUp }: any) => {
  const t = useFormatMessage();

  const onSubmit: SubmitHandler = (
    { new_password, new_password_confirm },
    formHelpers
  ) => {
    return api.resources
      .acceptOrganizationInvitation({
        new_password,
        new_password_confirm,
        key: params.key,
        organization_name: params.organization_name,
      })
      .then(({ data }) => {
        Cookies.set(AUTH.TOKEN, `${data.token}`, {
          path: '/',
          domain: env.IS_PRODUCTION ? '.deeptrue.com' : 'localhost',
        });
        signUp(data);
      })
      .catch(({ response }) => {
        if (errorsValidation.is400Group(response.status)) {
          formHelpers.setErrors(parseErrorsToFormik(response.data));
        }
      })
      .finally(() => {
        formHelpers.setSubmitting(false);
      });
  };

  return (
    <SidePage
      title="Setup password"
      splashImage={signInSplash}
      slogan={
        <Typography color="white" variant="h4" mt="8rem">
          {t(
            'pages.auth.header',
            "On deeptrue's workbenches you will find well-founded, ready-to-go insight tools"
          )}
        </Typography>
      }
    >
      <RecoverPassword onSubmit={onSubmit} />
    </SidePage>
  );
};

export default compose(
  connect(null, {
    signUp: actions.authActions.signUp,
  }),
  withMetaDescription({ title: 'Setup password' })
)(InvitationAcceptance);
